<script lang="ts">import { t, Verbiage } from "@infinitro/content";
import { getIcon } from "../data/icons";
const ProviderIcon = getIcon("ProviderIcon");
</script>

{#if typeof ProviderIcon === 'string'}
	<img src={ProviderIcon} alt={$t(Verbiage.icon_alt, 'alts')} />
{:else if typeof ProviderIcon === 'function'}
	<svelte:component this={ProviderIcon} />
{:else}
	<span>Invalid icon</span>
{/if}

<style>
</style>
